// Mapea el estado (status) de la orden a la etapa del flujo cronológico de
// REPARACIÓN (Entrega no forma parte de las etapas de reparación).
//
// Etapas:
//  1. diagnosis  → Problema + Diagnóstico
//  2. before     → Antes
//  3. during     → Durante reparación
//  4. after      → Reparado / Finalizado

export const STAGE_ORDER = ["diagnosis", "before", "during", "after"];

const STATUS_TO_STAGE = {
  RECEIVED: "diagnosis",
  IN_DIAGNOSIS: "diagnosis",
  WAITING_APPROVAL: "diagnosis",
  WAITING_PARTS: "diagnosis",
  NOT_REPAIRABLE: "diagnosis",
  CLIENT_REJECTED: "diagnosis",
  IN_REPAIR: "during",
  TESTING: "during",
  REPAIRED: "after",
  IN_TRANSFER: "after",
  READY: "after",
  DELIVERED: "after",
  IN_WARRANTY: "after",
};

export function stageForStatus(status) {
  return STATUS_TO_STAGE[status] || "diagnosis";
}

/** Devuelve 'completed' | 'current' | 'future' para una etapa dada, según el status actual. */
export function stageState(stageKey, currentStatus) {
  const currentStage = stageForStatus(currentStatus);
  const idxCur = STAGE_ORDER.indexOf(currentStage);
  const idx = STAGE_ORDER.indexOf(stageKey);
  if (idx < idxCur) return "completed";
  if (idx === idxCur) return "current";
  return "future";
}
